<template>
  <div class="h-full flex flex-col position-relative">
    <div class="m-b-2 p-x-3 port_table">
      <div class="port_table__check"><b-form-checkbox v-model="allSelected" :indeterminate="indeterminate" class="check-box" @change="checkAll"/></div>
      <div class="port_table__name fz12 text-gray-text">Port / Canal Name</div>
      <div class="port_table__draft fz12 text-gray-text text-align-center">Max Draft</div>
      <div class="port_table__cargo fz12 text-gray-text">Cargo</div>
      <div class="port_table__attachments fz12 text-gray-text text-align-center">Attachments</div>
      <div class="port_table__comments fz12 text-gray-text text-align-center">Comments</div>
      <div class="port_table__options m-l-auto"></div>
    </div>

    <div class="shadow-table bg-white rounded " v-if="searcPort.length">
      <div 
        class="p-x-3 p-y-1 border-b border-gray-dark port_table cursor-pointer "
        :class="{'border-b-0': i == searcPort.length-1}"
        v-for="(port, i) in searcPort" 
        :key="port.id"
        @click.stop.prevent="toPort(port.id)"
      >
        <div class="port_table__check" @click.stop><b-form-checkbox v-model="selectedPorts" :value="port.id"/></div>
        <div class="port_table__name" :title="port.name">{{port.name}}</div>
        <div class="port_table__draft text-align-center">{{port.max_draft}}</div>
        <div class="port_table__cargo">
          <span v-for="(pda, j) in port.pda" :key="pda.id">{{pda.cargo}}{{ port.pda.length-1 > j ? ', ':''}}</span>
        </div>
        <div class="port_table__attachments text-align-center">
          <svg v-if="port.files.length" class="svg-dart" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20c-2.757 0-5-2.243-5-5V8a.666.666 0 111.333 0v7A3.67 3.67 0 0012 18.667 3.67 3.67 0 0015.667 15V7.667a2.336 2.336 0 00-2.334-2.334A2.336 2.336 0 0011 7.667v6.666c0 .552.449 1 1 1 .551 0 1-.448 1-1V8a.666.666 0 111.333 0v6.333A2.336 2.336 0 0112 16.667a2.336 2.336 0 01-2.333-2.334V7.667A3.671 3.671 0 0113.333 4 3.671 3.671 0 0117 7.667V15c0 2.757-2.243 5-5 5z" fill="#4B4B4B"/></svg>
        </div>
        <div class="port_table__comments text-align-center">
          <svg v-if="port.has_messages" class="svg-dart" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.084 6.619a2.236 2.236 0 00-2.217-2.217H6.134A2.236 2.236 0 003.917 6.62v8.067a2.236 2.236 0 002.217 2.216h.472v1.695c0 .41.252.779.636.927l.003.002a.998.998 0 001.006-.177l3.6-2.447h6.016a2.236 2.236 0 002.217-2.216V6.619zm-2.217-.717c.381 0 .717.336.717.717v8.067c0 .38-.336.716-.717.716H11.62a.75.75 0 00-.422.13l-3.092 2.102v-1.482a.75.75 0 00-.75-.75H6.134a.737.737 0 01-.717-.716V6.619c0-.38.336-.717.717-.717h11.733z" fill="#4B4B4B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.75 9a.75.75 0 01.75-.75h7a.75.75 0 010 1.5h-7A.75.75 0 017.75 9zM7.75 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H8.5a.75.75 0 01-.75-.75z" fill="#4B4B4B"/></svg>
        </div>
        <div class="port_table__options m-l-auto text-align-right">
          <button class="fz0" v-if="port.is_archive && getPermissionsByType('archive_and_unarchive_ports')" @click.stop="$emit('on-unarchive', port)"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.017 9.785L6.713 7.002 9.017 4.22a.736.736 0 00-1.108-.967L5.182 6.519a.735.735 0 000 .967l2.727 3.267a.735.735 0 101.108-.968z" fill="#9AA3B0"/><path d="M13.654 6.266H5.736a.736.736 0 100 1.471h7.918c2.136 0 3.875 1.863 3.875 4.242 0 2.378-1.739 4.507-3.875 4.507H6.717a.736.736 0 100 1.472h6.937c2.947 0 5.346-2.746 5.346-5.98 0-3.233-2.398-5.712-5.346-5.712z" fill="#9AA3B0"/></svg></button>
          <options
            v-else-if="canPermission.length"
            :options="canPermission"
            @editItem="$emit('on-edit', port)"
            @duplicateItem="$emit('on-dupl', port)"
            @archiveItem="$emit('on-archive', port)"
          />
        </div>
      </div>
      <app-loader class="loader" :is-local="true" v-if="loadListLoader"></app-loader>
    </div>
    <pagination-panel-default @load-more="$emit('load-next')" :if-active="loadActive" v-if="next"></pagination-panel-default>

    <div class="p-b-15" v-if="searcPort.length"></div>

    <div v-if="searcPort.length == 0" class="text-align-center p-6 m-auto">
      <svg width="320" height="160" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M189.554 101.5a40.338 40.338 0 009.446-26c0-22.367-18.132-40.5-40.5-40.5S118 53.133 118 75.5c0 22.368 18.132 40.5 40.5 40.5 12.47 0 23.624-5.636 31.054-14.5zm0 0L214 125.946" stroke="#DEE3EA" stroke-width="2" stroke-linecap="round"/><path d="M40.41 81.467c.195-.107.442-.25.61-.399 1.596-1.421 3.707-1.427 5.31 0 1.056.941 2.422.941 3.479 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.31 0 .152.136.37.276.668.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.41-.212-.718-.414-.967-.636-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-.277.247-.6.436-.878.59-.363.198-.802.031-.98-.373-.18-.404-.03-.892.334-1.091zM48.41 88.467c.195-.107.442-.25.61-.399 1.596-1.421 3.707-1.427 5.31 0 1.056.941 2.422.941 3.479 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.31 0 .152.136.37.276.668.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.41-.212-.718-.414-.967-.636-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-.277.247-.6.436-.878.59-.363.198-.802.031-.98-.373-.18-.404-.03-.892.334-1.091z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M111 127.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6zM207 19.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6z" fill="#DEE3EA"/><path d="M221.409 55.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091zM230.409 61.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091zM260.409 99.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.586-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.421-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.421-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-.278.247-.6.436-.879.589-.363.199-.802.032-.981-.372-.178-.404-.029-.892.334-1.091z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M73 46.2a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zm0 1.8a5 5 0 100-10 5 5 0 000 10z" fill="#DEE3EA"/></svg>
      <p class="m-t-4 fz18 fw500">No results were found for your search</p>
    </div>
  </div>
</template>

<script>
import options from '@/components/reuse/options'
import { mapGetters } from 'vuex';
import PaginationPanelDefault from "@/components/ports/paginationDefault.vue";
import AppLoader from "@/components/loader.vue";

export default {
  components: {
    AppLoader,
    PaginationPanelDefault,
    options
  },
  props: {
    loadListLoader: Boolean,
    loadActive: Boolean,
    next: null,
    ports: Array,
    localSearch: String
  },
  data() {
    return {
      indeterminate: false,
      allSelected: false,
      selectedPorts: []
    }
  },
  watch: {
    selectedPorts(newValue) {
      if (newValue.length == 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.ports.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }

      this.$emit('on-select', this.selectedPorts)
    },
    ports: {
      deep: true,
      handler() {
        this.selectedPorts = []
      }
    }
  },
  computed: {
    ...mapGetters(['getPermissionsByType']),
    canPermission() {
      let arr = []
      if(this.getPermissionsByType('edit_ports')) arr.push('edit')
      if(this.getPermissionsByType('create_ports')) arr.push('duplicate')
      if(this.getPermissionsByType('archive_and_unarchive_ports')) arr.push('archive')
      return arr
    },
    searcPort() {
      if(!this.ports?.length) return []
      let localPorts = this.ports
      localPorts = localPorts.sort((a,b)=>{
        if (a.name > b.name) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        }
        return 0;
      })
      if(!this.localSearch) return localPorts
      return localPorts.filter(el => {
        let name = el.name.toLowerCase()
        return name.indexOf(this.localSearch.toLowerCase()) >= 0
      })
    }
  },
  methods: {
    checkAll(checked) {
      this.selectedPorts = checked ? this.ports.map((port) => {return port.id}) : []
    },
    uncheckAll() { // used in parent component
      this.selectedPorts = []
    },
    toPort(id) {
      if(this.$route.name != 'ports-archive') this.$router.push(`/ports/${id}/detail`)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./src/components/style-element/bootstrap";
  @import "./src/components/style-element/checkbox";
</style>

<style lang="scss">
.port_table{
  display: flex;
  align-items: center;
  &__check{
    width: 3.2%;
  }
  &__name,
  &__cargo{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__name{
    width: 23%;
  }
  &__draft{
    width: 9%;
  }
  &__cargo{
    width: 28%;
    padding-left: 2.3%;
  }
  &__attachments{
    width: 8%;
  }
  &__comments{
    width: 8%;
  }
  &__options{
    width: 3%;
  }
}
</style>
<style lang="scss" scoped>
.check-box {

}
.loader {
  border-radius: 8px;
}
</style>